/* eslint @typescript-eslint/no-explicit-any: 0 */

import Serializer from "./Serializer";
import { User } from "../../../app/types/User";

class UserSerializer extends Serializer<User> {
    public serialize(user: Partial<User>) {
        return {
            username: user.username,
            email: user.email,
        };
    }

    public deserialize(data: any): User {
        return {
            id: data.id,
            username: data.username,
            email: data.email,
            description: data.profile.bio,
            age: data.profile.age,
            gender: data.profile.gender,
            education: data.profile.education,
            hobby: data.profile.hobby,
        };
    }
}

export default UserSerializer;
